import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PromocodeDTO } from '../service/promocodes.interface';
import { useDeletePromocodeMutation } from '../service/promocode.api';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import { setCurrentPromocode } from '../store/promocode.slice';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const usePromocodeControls = () => {
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const current = useAppSelector(selectShopCurrent);

    const dispatch = useAppDispatch();

    const [deletePromocode] = useDeletePromocodeMutation();
    const copyPromocodes = (items: PromocodeDTO[]) => {
        const text = items.map(elem => elem.code).join('\n');
        navigator.clipboard
            .writeText(text)
            .then(() =>
                notification.success({ message: 'Промокоды скопированы' })
            );
    };

    const deletePromocodes = (item: PromocodeDTO[]) => {
        const payload = {
            shop_id: current.id,
            ids: item.map(elem => elem.id),
        };

        deletePromocode(payload);
    };

    const editPromocodes = (item: PromocodeDTO) => {
        navigate(`${item.id}/edit`);
        dispatch(setCurrentPromocode(item));
    };

    return { copyPromocodes, deletePromocodes, editPromocodes };
};
